import type { FC } from 'react';
import { ForgotPassword } from '../../features/forgot-password';

export const ForgotPasswordView: FC = () => <ForgotPassword />;
